// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"1f5fd092","44":"526ddb80","86":"3d0d4f6b","243":"29df4b70","367":"c26d26b7","371":"1442a682","482":"4c23294b","483":"1838f37b","638":"ab38bdfe","662":"592b41e7","837":"21e6c0a2","929":"3e47b81e","957":"30f84c70"}[chunkId] + ".chunk.js";
};